import { FacetSource } from "./buildSources";

export type TagItem = { label: string; originalSource: FacetSource };

export const tagItem = (source: FacetSource, label: string): TagItem => ({
  originalSource: source,
  label
});
